export const CHANGEPASSWORD_INITIATED = 'CHANGEPASSWORD_INITIATED';
export const CHANGEPASSWORD_SUCCESS = 'CHANGEPASSWORD_SUCCESS';
export const CHANGEPASSWORD_ERROR = 'CHANGEPASSWORD_ERROR';
